module.exports = __webpack_public_path__ + "img/ico-sources.f200315b.svg";